import { render, staticRenderFns } from "./ScreenshotModal.vue?vue&type=template&id=45f17e06&scoped=true"
import script from "./ScreenshotModal.vue?vue&type=script&lang=js"
export * from "./ScreenshotModal.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotModal.vue?vue&type=style&index=0&id=45f17e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f17e06",
  null
  
)

export default component.exports